import _ from 'lodash';
import config from './default';

const prod = _.cloneDeep(config);

prod.googleAnalyticsCode = 'UA-110840836-1';

export default prod;
